<template>
  <div class="cp-set-app-icon main">
    <div class="divider" />

    <div class="row">
      <p><i class="far fa-user-circle icon" />App Icon</p>
      <p class="value">
        The app icon can appear in a variety of shapes from square to circle,
        depending on the device.
      </p>
      <p class="image-label has-text-right has-text-grey">
        <span v-if="loading" class="is-pulled-left"
          ><i class="fa fa-spinner fa-spin" />&nbsp;Loading</span
        >
        <span v-else class="is-pulled-left">
          Min Safe Area
          <input type="checkbox" v-model="showSafeArea" />
        </span>
        <span @click="toggleIconShape">
          View icon as
          <toggle-button
            style="margin-left: 2px"
            :value="!isRound"
            :sync="true"
            :labels="{ checked: $t('Square'), unchecked: $t('Circle') }"
            :color="{ checked: '#777', unchecked: '#999' }"
            :height="25"
            :width="66"
            @change="toggleIconShape"
          />
        </span>
      </p>
      <p class="image-label">192x192px PNG Image</p>
      <p class="app-icon">
        <span class="button has-text-success is-pulled-right" @click="setPic">
          Change</span
        >
        <img
          :src="icon192Fallback"
          class="size-192"
          :class="[{ round: isRound }, { 'min-safe-area': showSafeArea }]"
        />
      </p>
      <p class="image-label">512x512px PNG Image</p>
      <p class="app-icon">
        <span class="button has-text-success is-pulled-right" @click="setPic">
          Change</span
        >
        <img
          :src="icon512Fallback"
          class="size-512"
          :class="[{ round: isRound }, { 'min-safe-area': showSafeArea }]"
          @load="loaded512()"
        />
      </p>
      <p v-if="!icon192" style="margin: 8px 0; font-weight: 500">
        <span class="button is-fullwidth" @click="useTemporaryAppIcons"
          >Use Temporary App Icons</span
        >
      </p>
    </div>

    <input
      type="file"
      ref="file"
      style="display: none"
      accept="image/png,image/jpeg,image/jpg,image/bmp"
      @change="setPicAWS($event)"
    />
  </div>
</template>


<script>
import imageCompression from "browser-image-compression";

export default {
  name: "CPSetAppIcon",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      app: "customer", // set in route query on mounted
      imageType: "profile", // should be 192 or 512
      icon192: null,
      icon512: null,
      isRound: false,
      showSafeArea: false,
      loading: true,
      // https://drive.google.com/drive/folders/1eTUAZjT48j5pI6bSP2DlfrkJVi7-t3eK?usp=sharing << stored them in gdrive
      fallbackIcons: {
        // app_name: [192px, 512px]
        customer: [
          "1c3LFKr34gQzJuG-7HEzJfSCHpQ8yUCJc",
          "1-c2FzGlZtzwMVcMETDDbzqLpwAZnAIlR",
        ],
        shop_manager: [
          "1QQxpFjNqgNa6wAVMTl2qXj-uJ2VrZ_z6",
          "1I7xNyxjX2uAPrh-wKB9u0TGtPNd8-wVt",
        ],
        commerce_agent: [
          "1gA2XOfAMq9JamCOVJ4LofKSOPgQffzZK",
          "1UIwR6NVP8EZcsmXz7qKVTYb5lIAyJm3Q",
        ],
        delivery_driver: [
          "1Nk7Li32zuj4UUr1HcM1pLA3rPaKD8cBC",
          "1WlIl4qbxeL608YnMq3mujvuHqOp7xDl5",
        ],
      },
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    icon192Fallback() {
      var icon = this.fallbackIcons[this.app][0];
      var fallback = "https://drive.google.com/uc?id=" + icon;
      return this.icon192 || fallback;
    },
    icon512Fallback() {
      var icon = this.fallbackIcons[this.app][1];
      var fallback = "https://drive.google.com/uc?id=" + icon;
      return this.icon512 || fallback;
    },
  },
  mounted() {
    this.app = this.$route.query.app;
    this.loading = true;
    var appData = this.business.data[this.app + "_app"];
    if (appData) {
      this.icon192 = appData.icon_192;
      this.icon512 = appData.icon_512;
    }
  },
  methods: {
    loaded512() {
      this.loading = false; // should also check image size is correct for 192 and 512
    },
    useTemporaryAppIcons() {
      var obj = {};
      var appKey = this.app + "_app";
      obj[appKey] = {
        icon_192: this.icon192Fallback,
        icon_512: this.icon512Fallback,
      };
      var loader = this.loadingDots();
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          data: obj,
        })
        .then((res) => {
          this.successToast("Updated app icons");
          this.business.data = res.data.data;
          this.appIconInfo();
          this.$store
            .dispatch("getAndSelectBusiness", this.business.id)
            .catch((err) => this.apiError(err));
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    appIconInfo() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='far fa-square'></i>&nbsp;Placeholder App Icons
        </p>
        <p style='margin-bottom:10px'>You can change the app icons here at any time.</p>
        <p style='margin-bottom:10px'>Users who have already installed the app will see the new app icon within a week.</p>
        <p>If you re-install the app you will see it immediately.</p>
        </div>`,
      });
    },
    toggleIconShape() {
      this.isRound = !this.isRound;
    },
    setPic() {
      this.$refs.file.click();
    },
    savePicURL(picURL) {
      var obj = { id: this.business.id };
      var picType = `${this.imageType}_pic_url`; // banner_pic_url
      obj[picType] = picURL;
      this.$store
        .dispatch("updateBusiness", obj)
        .then(() => {
          this.business[picType] = picURL;
          this.successToast("Success!");
        })
        .catch((err) => this.apiError(err));
    },
    setPicAWS(e) {
      if (!e.target.files) return;
      if (!e.target.files.length) return;
      var originalFile = e.target.files[0];

      var loader = this.loadingDots();
      var options = {
        maxSizeMB: 0.3,
        maxWidthOrHeight: 400,
        useWebWorker: true,
      };
      imageCompression(originalFile, options)
        .then((compressedFile) => {
          var sizeKB = Math.round(compressedFile.size / 1024);
          this.console(`compressedFile size ${sizeKB} KB`); // smaller than maxSizeMB

          imageCompression
            .getDataUrlFromFile(compressedFile)
            .then((base64) => {
              var data = {
                name: this.$shortid.generate() + ".png",
                content: base64.replace(/^data:image\/[a-z]+;base64,/, ""),
                businessID: this.business.id,
                imageType: this.imageType,
              };
              this.$store
                .dispatch("uploadImageAWS", data)
                .then((res) => {
                  console.log("uploadImageAWS", res.data);
                  var newPicURL = res.data.compressed_image_url;
                  this.savePicURL(newPicURL);
                })
                .catch((err) => this.apiError(err))
                .finally(() => loader.hide());
            })
            .catch((err) => this.console("imageData error", err));
        })
        .catch((err) => this.console("imageCompression error", err));
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.value {
  color: grey;
  margin-left: 32px;
  /* border-bottom: 1px dotted rgb(230, 230, 230); */
}
.image-label {
  margin-left: 32px;
  margin-top: 10px;
  font-size: 0.9em;
  font-weight: 500;
}
.save-wrapper {
  margin-top: 10px;
  text-align: right;
}
.app-icon {
  margin-left: 32px;
  margin-top: 10px;
}
.app-icon img {
  display: inline-block;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
  object-fit: cover;
  border-radius: 20%;
  transition: all 0.3s;
  background-color: #ccc;
}
.size-192 {
  height: 90px;
  width: 90px;
}
.size-512 {
  height: 120px;
  width: 120px;
}
.round {
  border-radius: 100px !important;
  transition: all 1s linear;
}
.min-safe-area {
  clip-path: inset(10% round 50%);
}
</style>
